import { secureBusinessFields } from '../rates';
import { getDiscountAmountSum } from '../../../utils/utils';
import {
  fieldSecureBusinessOffers,
  fieldTelusSecureBusinessSecurityPackage,
  sixMonthsFree,
  smartCameraKey,
  tsbSecurityOffersObject
} from '../../../utils/constant';
import { getFieldValue } from '../../utils';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const locale = getLocale();
const {
  contentfulValues: {
    secureBusinessOffers: {
      threeMonthFree,
      tenOffWirelene,
      twentyOffWireline,
      zeroInstallation
    }
  }
} = locale === 'en-US' ? EN : FR;

export const updateSecureBusinessRates = (formFields, dueMonthly, newValue) => {
  let addAmountToMonthly = 0;
  let subtractAmountFromMonthly = 0;

  const {
    secureBusinessPackageRates,
    secureBusinessOfferDiscounts
  } = secureBusinessFields;

  const secureBusinessOffersValue = getFieldValue(fieldSecureBusinessOffers, formFields) || [];
  const secureBusinessPackageOldValue = getFieldValue(fieldTelusSecureBusinessSecurityPackage, formFields);

  // this is hotfix to handle 6 months and 3 months offers in TSB
  if (newValue === smartCameraKey
    && secureBusinessOffersValue.includes(zeroInstallation)
    && secureBusinessOffersValue.length === 1
  ) {
    // eslint-disable-next-line no-param-reassign
    formFields[fieldSecureBusinessOffers].value = undefined;
  }

  if (newValue === smartCameraKey
    && (secureBusinessOffersValue.includes(threeMonthFree) ||
      secureBusinessOffersValue.includes(twentyOffWireline) ||
      secureBusinessOffersValue.includes(tenOffWirelene) ||
      secureBusinessOffersValue.includes(sixMonthsFree) ||
      secureBusinessOffersValue.includes(tsbSecurityOffersObject.sixMonthsFreeEn))) {
    // eslint-disable-next-line no-param-reassign
    formFields[fieldSecureBusinessOffers].value = undefined;
    if (dueMonthly === 0) {
      addAmountToMonthly += 15;
    } else if (dueMonthly > 0 && secureBusinessOffersValue.includes(tenOffWirelene)) {
      addAmountToMonthly += 15;
      subtractAmountFromMonthly += 15;
    } else {
      addAmountToMonthly += 15;
      subtractAmountFromMonthly += -5;
    }
  }

  if (newValue
    && (secureBusinessOffersValue.includes(threeMonthFree)
      || secureBusinessOffersValue.includes(sixMonthsFree)
      || secureBusinessOffersValue.includes(tsbSecurityOffersObject.sixMonthsFreeEn))) {
    addAmountToMonthly += secureBusinessPackageRates[secureBusinessPackageOldValue];
    subtractAmountFromMonthly += secureBusinessPackageRates[newValue];
    // hotfix ends
  } else if (secureBusinessPackageOldValue) {
    const currentDiscountAmountSum = getDiscountAmountSum(secureBusinessOfferDiscounts, secureBusinessOffersValue);
    addAmountToMonthly += secureBusinessPackageRates[secureBusinessPackageOldValue] >= currentDiscountAmountSum
      ? currentDiscountAmountSum
      : secureBusinessPackageRates[secureBusinessPackageOldValue];
    subtractAmountFromMonthly += secureBusinessPackageRates[newValue] >= currentDiscountAmountSum
      ? currentDiscountAmountSum
      : secureBusinessPackageRates[newValue];
  }

  return {
    addAmountToMonthly,
    subtractAmountFromMonthly
  };
};
